import React, { useState } from "react";
import { Tabs } from "antd";
// import { Dashboard } from "./Dashboard";
import { DataAnalysis } from "./DataAnalysis";
import AlertIcon from "../../Img/alert-icon.svg";
import DashboardIcon from "../../Img/dashboard-icon.svg";
import DataAnalysisIcon from "../../Img/data-analysis-icon.svg";
import AlertsList from "./NewDashboard/Alerts/AlertsList";
import Dashboard from "./NewDashboard/Dashboard/Dashboard";
import PatientListCycles from "./NewDashboard/PatientListCycles/PatientListCycles";
import { useSelector } from "react-redux";

const Home = () => {
  const [activeTab, setActiveTab] = useState("dashboard");

  let UserPreferences = localStorage.getItem("UserPreferences");

  if (UserPreferences) {
    UserPreferences = JSON.parse(window.atob(UserPreferences));
  }

  const { notificationList } = useSelector(({ notification }) => notification);

  const items = [
    {
      key: "dashboard",
      label: "Dashboard",
      icon: DashboardIcon,
      children: <Dashboard />,
    },
    {
      key: "alerts",
      label: "Alerts",
      icon: AlertIcon,
      children: <AlertsList />,
    },
    {
      key: "dataAnalysis",
      label: "Data Analysis",
      icon: DataAnalysisIcon,
      children: <DataAnalysis />,
    },
  ];

  return (
    <>
      <div className="page_main_content p-0">
        <div className="page_inner_content border-0 p-0">
          <PatientListCycles />
          <div className="dashboard_tab_list">
            <Tabs
              defaultActiveKey="1"
              activeKey={activeTab}
              onTabClick={(key) => setActiveTab(key)}
            >
              {items.map((item) => (
                <Tabs.TabPane
                  key={item.key}
                  tab={
                    <span>
                      <img src={item.icon} alt="" style={{ marginRight: 8 }} />

                      {item.label}

                      {notificationList?.unreadCount
                        ? item.key === "alerts" && (
                            <span class="badge bg-danger rounded-circle">
                              {notificationList?.unreadCount}
                            </span>
                          )
                        : ""}
                    </span>
                  }
                >
                  {item.children}
                </Tabs.TabPane>
              ))}
            </Tabs>
          </div>
        </div>
      </div>

      {/* <div className="page_main_content">
        {UserPreferences?.other ? (
          <Dashboard />
        ) : (
          <Tabs
            defaultActiveKey="1"
            activeKey={activeTab}
            onTabClick={(key) => setActiveTab(key)}
          >
            {items.map((item) => (
              <Tabs.TabPane tab={item.label} key={item.key}>
                {item.children}
              </Tabs.TabPane>
            ))}
          </Tabs>
        )}
      </div> */}
    </>
  );
};

export default Home;
